import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentService } from '../_services/document.services';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../_services/authentication.service';
import { Category, User } from '../_models';
import { AppConfig } from 'src/assets/config/config/app-config';
import { UsersAndGroupsService } from '../_services/users-and-groups.service';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss']
})

export class StatusComponent implements OnInit {
  currentUser: User;
  userGroups: string[];
  display: boolean = false;
  isAdmin: boolean = false;


  constructor(
    private authenticationService: AuthenticationService,
    private usersGroupsService: UsersAndGroupsService,
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.userGroups = authenticationService.userGroupsValue; 
    this.usersGroupsService.getAdminGroupName().subscribe((admin:any) => {
      for (let i = 0; i < this.userGroups.length; i++) {
          if (admin.indexOf(this.userGroups[i]) >= 0) {
              this.isAdmin = true;
              break;
          }
      }
    });
  }

  ngOnInit(): void {
    this.display = true;
  }

}